import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { subscribeBackendUnavailable } from '../utils/backendUnavailable';

/**
 * Dev-only banner when API returns 503 (backend at 127.0.0.1:5001 not running).
 * Shows once so the user knows to start the backend: pnpm run dev:server
 */
export function BackendUnavailableBanner(): React.ReactElement | null {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (import.meta.env.PROD) return;
    const unsub = subscribeBackendUnavailable(() => {
      setShow(true);
    });
    return unsub;
  }, []);

  if (!import.meta.env.DEV || !show || dismissed) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        bgcolor: 'warning.dark',
        color: 'warning.contrastText',
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
        boxShadow: 2,
      }}
      role="alert"
    >
      <Typography variant="body2" component="span">
        Backend unavailable (503). Start it with: <code style={{ background: 'rgba(0,0,0,0.2)', padding: '2px 6px', borderRadius: 4 }}>pnpm run dev:server</code> or <code style={{ background: 'rgba(0,0,0,0.2)', padding: '2px 6px', borderRadius: 4 }}>pnpm run dev</code>
      </Typography>
      <Button
        size="small"
        variant="outlined"
        onClick={() => setDismissed(true)}
        sx={{ color: 'inherit', borderColor: 'currentColor', flexShrink: 0 }}
      >
        Dismiss
      </Button>
    </Box>
  );
}
